export const WHATSAPP_URL = "https://wa.me/919017099187";
export const PHONE = "+91 90170 99187";
export const LOGO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_comfort-crafted-7/artifacts/cq1sgmgr_SleepVistaLogo.png";
export const ICON_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_comfort-crafted-7/artifacts/cq1sgmgr_SleepVistaLogo.png";
export const ADDRESS =
  "Plot no. 1117, Gram Sabha Main Rd, near Rose Convent School, Sardar Patel Enclave, Pooth Kalan, Rohini, Delhi 110086";

export const IMAGES = {
  hero:
    "https://images.pexels.com/photos/6489100/pexels-photo-6489100.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  manifesto:
    "https://images.pexels.com/photos/8089071/pexels-photo-8089071.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  materials:
    "https://images.pexels.com/photos/7630252/pexels-photo-7630252.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  pillow:
    "https://images.unsplash.com/photo-1600414428640-f78a67c2aa3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxjb21mb3J0YWJsZSUyMHNsZWVwaW5nJTIwcGlsbG93fGVufDB8fHx8MTc4NDk3ODQzOHww&ixlib=rb-4.1.0&q=85",
  fabric:
    "https://images.unsplash.com/photo-1599163666602-ef737d996c16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxtZW1vcnklMjBmb2FtJTIwbGF5ZXJzJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODQ5Nzg0Mzh8MA&ixlib=rb-4.1.0&q=85",
  bedWhite:
    "https://images.unsplash.com/photo-1584100936595-c0654b55a2e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxjb21mb3J0YWJsZSUyMHNsZWVwaW5nJTIwcGlsbG93fGVufDB8fHx8MTc4NDk3ODQzOHww&ixlib=rb-4.1.0&q=85",
  bedTray:
    "https://images.unsplash.com/photo-1737467030068-88ad20e617ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwbWF0dHJlc3MlMjBtaW5pbWFsJTIwYmVkcm9vbXxlbnwwfHx8fDE3ODQ5Nzg0Mzh8MA&ixlib=rb-4.1.0&q=85",
};

// span: layout hint for the asymmetric bento grid
export const PRODUCTS = [
  {
    id: "orthopedic",
    index: "01",
    name: "Orthopedic",
    tagline: "Engineered spinal alignment",
    description:
      "A high-density support core that cradles pressure points and keeps the spine in its natural line — recommended for back care.",
    image: IMAGES.bedTray,
    span: "lg:col-span-7",
  },
  {
    id: "memory-foam",
    index: "02",
    name: "Memory Foam",
    tagline: "Contour & recover",
    description:
      "Visco-elastic layers that respond to body heat, moulding to your shape and returning slowly to form.",
    image: IMAGES.fabric,
    span: "lg:col-span-5",
  },
  {
    id: "hr-foam",
    index: "03",
    name: "HR Foam",
    tagline: "High resilience bounce",
    description:
      "Superior rebound and durability for years of consistent, breathable comfort.",
    image: IMAGES.bedWhite,
    span: "lg:col-span-5",
  },
  {
    id: "pu-foam",
    index: "04",
    name: "PU Foam",
    tagline: "Everyday comfort",
    description:
      "Versatile polyurethane foam mattresses balancing softness, support and value.",
    image: IMAGES.manifesto,
    span: "lg:col-span-7",
  },
  {
    id: "soft-foam",
    index: "05",
    name: "Soft Foam",
    tagline: "Plush & cushioned",
    description:
      "A gentle, sink-in feel for those who love a soft, hotel-like surface.",
    image: IMAGES.hero,
    span: "lg:col-span-4",
  },
  {
    id: "spring",
    index: "06",
    name: "Spring",
    tagline: "Pocketed & bonnell",
    description:
      "Individually responsive coils topped with premium foam for balanced airflow and support.",
    image: IMAGES.bedTray,
    span: "lg:col-span-4",
  },
  {
    id: "sofa-foam",
    index: "07",
    name: "Sofa Foam",
    tagline: "Seating that lasts",
    description:
      "Custom-cut, high-density foam for sofas and upholstery that never loses shape.",
    image: IMAGES.materials,
    span: "lg:col-span-4",
  },
  {
    id: "pillows",
    index: "08",
    name: "Pillows",
    tagline: "The finishing touch",
    description:
      "Memory foam and fibre pillows crafted for the perfect neck cradle.",
    image: IMAGES.pillow,
    span: "lg:col-span-12",
  },
];

export const MANIFESTO = [
  {
    number: "01",
    title: "Craft over compromise",
    body: "For over a decade in Rohini, Delhi, we have manufactured foam the honest way — dense cores, breathable layers, and finishing that lasts a lifetime, not a season.",
  },
  {
    number: "02",
    title: "The science of stillness",
    body: "Deep sleep is architecture. Every layer we pour is calibrated for pressure relief, airflow and spinal alignment — so your body can finally let go.",
  },
  {
    number: "03",
    title: "Made to your measure",
    body: "From orthopedic cores to custom sofa foam, everything is built to order in our own factory. No middlemen, no shortcuts — just foam, perfected.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Best foam quality in the area. The orthopedic mattress completely changed my sleep and my back pain is gone.",
    author: "Verified Customer",
    role: "Rohini, Delhi",
  },
  {
    quote:
      "Custom sofa foam cut exactly to size, delivered on time. Genuinely premium and priced fairly.",
    author: "Verified Customer",
    role: "Delhi NCR",
  },
];
